<template>
  <EdroneResultState type="empty" class="tw:flex tw:flex-col tw:justify-center tw:items-center tw:h-full tw:w-full">
    <template #top-icon>
      <FontAwesomeIcon icon="fa-light fa-inbox" />
    </template>

    <h3 class="tw:heading-2 tw:mb-1">{{ trans._menu.searchBar.emptyHeader }}</h3>

    <p class="tw:body-2 tw:!text-default-700 tw:mb-4">{{ description }}</p>
  </EdroneResultState>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import EdroneResultState from "edrone-components/EdroneResultState.vue";
import { computed } from "vue";
import { SEARCH_BAR_GROUP } from "vue-app/components/SearchBar/SearchBar.constants";

interface Props {
  groupBy: SEARCH_BAR_GROUP;
  query: string;
}

const props = defineProps<Props>();

const description = computed(() => {
  const isGroupByProducts = props.groupBy === SEARCH_BAR_GROUP.PRODUCTS;

  const label = isGroupByProducts
    ? window._trans._menu.searchBar.emptyDescriptionProducts
    : window._trans._menu.searchBar.emptyDescription;

  return label.replace("{{query}}", props.query);
});
</script>
